export default __webpack_public_path__ + "static/media/qat.658fc426.svg";